function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import hoistNonReactStatics from 'hoist-non-react-statics';
import merge from 'lodash/merge';
import remove from 'lodash/remove';
import queryString from 'qs';
import deobfuscateString from '@domain-group/fe-allhomes-library/lib/utils/deobfuscate-string';
import { subjects } from '@domain-group/fe-co-allhomes-global-observer';
import { setHOCDisplayName } from '@domain-group/fe-helper';
import { quickLinks as defaultQuickLinks } from '../utils/quick-links';

/* eslint-disable react/forbid-prop-types */
import { jsx as ___EmotionJSX } from "@emotion/core";
var quickLinksFetcher = BaseComponent => {
  class ComponentWithFetcher extends React.Component {
    constructor(props) {
      var _this;
      super(props);
      _this = this;
      _defineProperty(this, "onFooterOptionsChange", function () {
        var newOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (_this.state.options.divisionId !== newOptions.divisionId) {
          var options = merge({}, _this.state.options);
          options.divisionId = newOptions.divisionId;
          _this.fetchQuickLinks(options).then(quickLinks => {
            var isEuUser = Boolean(options.isEuUser);
            if (isEuUser) {
              remove(quickLinks[quickLinks.length - 1].items, {
                label: 'Agency Registration'
              });
            }
            _this.setState({
              options,
              quickLinks
            });
          }).catch(() => {
            // Do nothing
          });
        }
      });
      _defineProperty(this, "fetchQuickLinks", options => {
        var params = queryString.stringify(this.sanitiseOptions(options), {
          filter: (prefix, value) => value || undefined
        });
        var requestUrl = deobfuscateString(this.props.quickLinksEndpoint);
        if (params) {
          requestUrl += "?".concat(params);
        }
        return fetch(requestUrl).then(response => {
          if (!response.ok) {
            return Promise.reject();
          }
          return response.json();
        });
      });
      _defineProperty(this, "sanitiseOptions", options => {
        var sanitised = options;
        if (options.state) {
          merge(sanitised, {
            state: options.state.toUpperCase().trim()
          });
        }
        if (options.siteContext) {
          merge(sanitised, {
            siteContext: options.siteContext.toUpperCase().trim()
          });
        }
        return sanitised;
      });
      var _options = props.options,
        _quickLinks = props.quickLinks;
      this.state = {
        options: _options,
        quickLinks: _quickLinks
      };
    }
    componentDidMount() {
      this.props.subscribeObserver(subjects.dynamicFooterUpdate, this.onFooterOptionsChange);
      this.onFooterOptionsChange(this.props.options);
    }
    componentWillUnmount() {
      this.props.unsubscribeObserver(subjects.dynamicFooterUpdate, this.onFooterOptionsChange);
    }
    render() {
      return ___EmotionJSX(BaseComponent, _extends({}, this.props, {
        quickLinks: this.state.quickLinks
      }));
    }
  }
  ComponentWithFetcher.propTypes = {
    quickLinks: PropTypes.array,
    quickLinksEndpoint: PropTypes.string,
    options: PropTypes.object,
    subscribeObserver: PropTypes.func,
    unsubscribeObserver: PropTypes.func
  };
  ComponentWithFetcher.defaultProps = {
    options: {},
    subscribeObserver: () => {},
    unsubscribeObserver: () => {},
    quickLinksEndpoint: '/wsvc/feprops/footer/quicklinks',
    quickLinks: defaultQuickLinks
  };
  setHOCDisplayName(ComponentWithFetcher, BaseComponent, 'quickLinksFetcher');
  return hoistNonReactStatics(ComponentWithFetcher, BaseComponent);
};
export default quickLinksFetcher;